import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiService } from "../services/base-api.service";
import { HelpersService } from "../services/helpers.service";
import { ProgressService } from "../services/progress.service";
import { LoadingService } from "../services/loading.service";

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseApiService<any> {
  constructor(
    public override http: HttpClient,
    public override helper: HelpersService,
    public override loading: ProgressService,
    public override loadingService: LoadingService,
  ) {
    super(http, helper, loading, loadingService);
    this.endpoint = 'users';
    this.query = { limit: 0, page: 0 };
  }
}
